import {
  EditorState,
  Modifier,
  SelectionState,
  DraftEntityMutability,
} from 'draft-js';
import { getCurrentBlock } from './getCurrentBlock';
import { getCaretPosition } from './getCaretPosition';

// append message to curr editor state with decorator,  then return the
// new EditorState
export const appendDecoratedMessage = (
  decoratorType: string,
  mutableValue: DraftEntityMutability,
  decoratorData: any,
  editorState: EditorState,
  text: string,
  selectorPos: number,
) => {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity(
    decoratorType,
    mutableValue,
    decoratorData,
  );
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const block = getCurrentBlock(editorState);
  const blockKey = block ? block.getKey() : '';

  const contentStateWithReplacedText = Modifier.replaceText(
    contentStateWithEntity,
    new SelectionState({
      anchorKey: blockKey,
      anchorOffset: selectorPos,
      focusKey: blockKey,
      focusOffset: getCaretPosition(editorState),
      isBackward: false,
      hasFocus: true,
    }),
    text,
    undefined,
    entityKey,
  );
  const newEditorState = EditorState.set(editorState, {
    currentContent: contentStateWithReplacedText,
    selection: new SelectionState({
      anchorKey: blockKey,
      anchorOffset: selectorPos + text.length,
      focusKey: blockKey,
      focusOffset: selectorPos + text.length,
      isBackward: false,
      hasFocus: true,
    }),
  });

  return newEditorState;
};
